import { styled } from "@mui/material";
import { tokens } from "@styles/tokens";

/**
 * Bare text input for use inside a FieldCard — no border/background of its own
 * (the card provides those). Number variants hide the spinners.
 */
export const FieldInput = styled("input")(({ theme }) => ({
  width: "100%",
  border: "none",
  outline: "none",
  background: "transparent",
  fontFamily: tokens.font.family,
  fontSize: tokens.font.size.body[0],
  color: theme.skuey.ink,
  "&::placeholder": { color: theme.skuey.subtle, opacity: 1 },
  MozAppearance: "textfield",
  "&::-webkit-outer-spin-button, &::-webkit-inner-spin-button": {
    WebkitAppearance: "none",
    margin: 0,
  },
}));

/** Multiline counterpart for description/notes fields (use FieldCard align="start"). */
export const FieldTextarea = styled("textarea")(({ theme }) => ({
  width: "100%",
  border: "none",
  outline: "none",
  background: "transparent",
  resize: "vertical",
  minHeight: 60,
  fontFamily: tokens.font.family,
  fontSize: tokens.font.size.body[0],
  color: theme.skuey.ink,
  "&::placeholder": { color: theme.skuey.subtle, opacity: 1 },
}));
